import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

import { tagSearchPath } from './utils';

const TagLinks = ({ tags, compact = false }) => {
  const cleanTags = (tags || []).filter(Boolean);

  if (!cleanTags.length) return null;

  return (
    <div className={compact ? 'ehon-tags ehon-tags-compact' : 'ehon-tags'}>
      {cleanTags.map((tag) => (
        <UniversalLink href={tagSearchPath(tag)} key={tag}>
          #{tag}
        </UniversalLink>
      ))}
    </div>
  );
};

TagLinks.propTypes = {
  compact: PropTypes.bool,
  tags: PropTypes.arrayOf(PropTypes.string),
};

export default TagLinks;
